export default "__VITE_ASSET__DMG70zjT__"